import { WSAlert } from "@wingspanhq/fe-component-library";
import { PayerPayeeLinkRequest } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { queriesLinkRequests } from "@query";

type Props = {
  linkRequest: PayerPayeeLinkRequest;
};

/**
 * A single pending v3 invitation the logged-in user can accept. Accepting links
 * the two accounts and is scoped to the authenticated session: SDK 1.4.0's
 * `acceptLinkRequest` infers the accepting account from the session and dropped
 * the explicit `acceptingAccountId` body. The payer/payee lists are invalidated
 * alongside the link-request list from the mutation's registry config.
 */
export const PendingInvitationAlert: React.FC<Props> = props => {
  const [acceptLinkRequest, acceptMeta] =
    queriesLinkRequests.acceptLinkRequest.useMutation();

  const handleAccept = () => {
    acceptLinkRequest({
      linkRequestId: props.linkRequest.id
    });
  };

  return (
    <WSAlert
      theme="info"
      icon="envelope"
      title="Pending invitation"
      action={{
        text: "Accept invitation",
        onClick: handleAccept,
        loading: acceptMeta.isLoading
      }}
    >
      You have a pending invitation to connect on Wingspan. Accept to start
      working together.
    </WSAlert>
  );
};
